import { render, staticRenderFns } from "./gitImgCom.vue?vue&type=template&id=661a09c8&scoped=true&"
import script from "./gitImgCom.vue?vue&type=script&lang=ts&"
export * from "./gitImgCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661a09c8",
  null
  
)

export default component.exports